export default __webpack_public_path__ + "static/media/shot-3.9b0e3e97.png";